export const TOGGLE_FEEDBACK_MODAL = 'TOGGLE_FEEDBACK_MODAL';
export const LOGOUT = 'LOGOUT';
export const POST_USER = 'POST_USER';
export const POST_LOGIN = 'POST_LOGIN';
export const GET_USER = 'GET_USER';
export const PATCH_USER = 'PATCH_USER';
export const PATCH_PASSWORD_RESET = 'PATCH_PASSWORD_RESET';
export const POST_PASSWORD_RESET = 'POST_PASSWORD_RESET';

export const GET_DICTIONARIES = 'GET_DICTIONARIES';

export const GET_USER_BILLING = 'GET_USER_BILLING';
export const POST_USER_BILLING = 'POST_USER_BILLING';
export const PATCH_USER_BILLING = 'PATCH_USER_BILLING';

export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_SHOWCASES = 'GET_SHOWCASES';

export const GET_DISTRIBUTORS = 'GET_DISTRIBUTORS';
export const GET_CITIES = 'GET_CITIES';

export const GET_PROJECTS = 'GET_PROJECTS';
export const POST_PROJECT = 'POST_PROJECT';
export const PATCH_PROJECT = 'PATCH_PROJECT';

export const GET_APPLICATIONS = 'GET_APPLICATIONS';
export const POST_APPLICATION = 'POST_APPLICATION';
export const PATCH_APPLICATION = 'PATCH_APPLICATION';

export const SEND_FEEDBACK = 'SEND_FEEDBACK';

export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const POST_NOTIFICATIONS_MARK = 'POST_NOTIFICATIONS_MARK';
export const GET_MESSAGES = 'GET_MESSAGES';
export const POST_MESSAGE = 'POST_MESSAGE';

export const ADD_CHECK = 'ADD_CHECK';

export const GET_BONUSES = 'GET_BONUSES';

export const SEND_SMS = 'SEND_SMS';

export const GET_ALL_APPLICATIONS = 'GET_ALL_APPLICATIONS';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js